import CommonConversation from '../commons/Conversation'

export default class DocumentConversation extends CommonConversation {
}
